import React, { Suspense, lazy } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import PageLoader from './components/Common/PageLoader';
import Base from './components/Layout/Base';
import BasePage from './components/Layout/BasePage';
import config from './helper/Config';
import PropTypes from 'prop-types';
import configureStore from './store/store';
import ls from 'localstorage-slim';
const STORAGE_KEY = `/${config.BASE_PATH}`;

const store = configureStore()
let search = location.search;
let params = new URLSearchParams(search);
// List of routes that uses the page layout
// listed here to Switch between layouts
// depending on the current pathname
const listofPages = [
    `/login`,
    `/loginsuccess`,
    `/lock`,
    `/resetpassword`,
    `/notfound`,
    `/error500`,
    `/maintenance`,
    `/unauthorized`,
    `/logout`
];

let baseUrl = "";
let paths = location.pathname.split('/') || '/';

if(config.BASE_URL!=""){
    baseUrl = `/${config.BASE_URL}`
}

if(location?.pathname?.includes('/resetpassword') || location?.search?.includes('resetpassword')){
    
    if(config.BASE_URL!=""){
        paths.splice(0, config.BASE_URL.split('/').length + 1)
        baseUrl = `/${config.BASE_URL}`
    }
    else
        paths.splice(0,1)
    
    // history.pushState({}, null, destination);
    let urlDest = `${baseUrl}/resetpassword?${!paths[0]?"":"redirect="+paths.join('/')}&${params.toString()}`
    history.pushState({}, null, urlDest);
}
else if(location?.pathname?.includes('/lock') || location?.search?.includes('lock')){
    // do nothing
}
else if((location?.pathname?.includes('/listvalue') || location?.search?.includes('listvalue')) && !location?.pathname?.includes('/listvaluecategory')){
    // do nothing
}
else if(location?.pathname?.includes('/unauthorized') || location?.search?.includes('unauthorized')){
    
    if(config.BASE_URL!=""){
        paths.splice(0, config.BASE_URL.split('/').length + 1)
        baseUrl = `/${config.BASE_URL}`
    }
    else
        paths.splice(0,1)

    history.pushState({}, null, `${baseUrl}/unauthorized?${!paths[0]?"":"redirect="+paths.join('/')}&${params.toString()}`);
}
else if(Object.keys(store.getState().user.userInfo).length<1 && listofPages.indexOf(location.pathname) == -1){
    if(config.BASE_URL!=""){
        paths.splice(0, config.BASE_URL.split('/').length + 1)
        baseUrl = `/${config.BASE_URL}`
    }
    else
        paths.splice(0,1)
    
    history.pushState({}, null, `${baseUrl}/login?${!paths[0]?"":"redirect="+paths.join('/')}&${params.toString()}`);
} else if (Object.keys(store.getState().user.userInfo).length>=1 && location.pathname.toLowerCase() == '/logout') {
    if(config.BASE_URL!=""){
        paths.splice(0, config.BASE_URL.split('/').length + 1)
        baseUrl = `/${config.BASE_URL}`
    }
    else
        paths.splice(0,1)

    history.pushState({}, null, `${baseUrl}/logout?${!paths[0]?"":"redirect="+paths.join('/')}&${params.toString()}`);
}
else if(Object.keys(store.getState().user.userInfo).length>=1 && listofPages.indexOf(location.pathname) > -1){
    history.pushState({}, null, `${baseUrl}/home`);
}

/* Used to render a lazy component with react-router */
const waitFor = Tag => {
    const WrappedComponent = props => <Tag {...props}/>;
    WrappedComponent.displayName = `waitFor(${Tag.displayName || Tag.name || 'Component'})`;
    return WrappedComponent;
};

// #region object page
let Page = {};
Page['Login'] = lazy(() => import('./components/Pages/Login'));
Page['ResetPassword'] = lazy(() => import('./components/Pages/ResetPassword'));
Page['Lock'] = lazy(() => import('./components/Pages/Lock'));
Page['NoAccess'] = lazy(() => import('./components/Pages/NoAccess'));
Page['Home'] = lazy(() => import('./components/Pages/Home'));
Page['Profil'] = lazy(() => import('./components/Profil/Profil'));
Page['Authorized'] = lazy(() => import('./components/Pages/Authorized'));
Page['UnAuthorized']= lazy(() => import('./components/Pages/UnAuthorized'));
Page['logout'] = lazy(() => import('./components/Pages/Logout'));

Page['category'] = lazy(() => import('./components/Product/CategorySetup/ViewCategory'));
Page['categoryForm'] = lazy(() => import('./components/Product/CategorySetup/FormCategory'));

Page['department'] = lazy(() => import('./components/Product/ItemDepartmentSetup/ViewItemDepartment'));
Page['departmentForm'] = lazy(() => import('./components/Product/ItemDepartmentSetup/FormItemDepartment'));

Page['attribute'] = lazy(() => import('./components/Product/AttributeSetup/ViewAttribute'));
Page['attributeForm'] = lazy(() => import('./components/Product/AttributeSetup/FormAttribute'));    

Page['bundle'] = lazy(() => import('./components/Product/BundleSetup/ViewBundle'));
Page['bundleForm'] = lazy(() => import('./components/Product/BundleSetup/FormBundle'));

Page['collection'] = lazy(() => import('./components/Product/CollectionSetup/ViewCollection'));
Page['collectionForm'] = lazy(() => import('./components/Product/CollectionSetup/FormCollection'));

Page['product'] = lazy(() => import('./components/Product/ProductSetup/ViewProduct'));
Page['productForm'] = lazy(() => import('./components/Product/ProductSetup/FormProduct'));

Page['orderingmenu'] = lazy(() => import('./components/QROrdering/MenuSetup/ViewMenu'));
Page['orderingmenuForm'] = lazy(() => import('./components/QROrdering/MenuSetup/FormMenu'));

Page['promotion'] = lazy(() => import('./components/Product/PromotionSetup/ViewPromotion'));
Page['promotionForm'] = lazy(() => import('./components/Product/PromotionSetup/FormPromotion'));

Page['warehouseproductmapping'] = lazy(() => import('./components/Product/WarehouseProductMapping/ViewWarehouseProductMapping'));

Page['stocktemplate'] = lazy(() => import('./components/Product/StockTemplateSetup/ViewStockTemplate'));
Page['stocktemplateForm'] = lazy(() => import('./components/Product/StockTemplateSetup/FormStockTemplate'));

Page['currency'] = lazy(() => import('./components/Sales/CurrencySetup/ViewCurrency'));
Page['currencyForm'] = lazy(() => import('./components/Sales/CurrencySetup/FormCurrency'));

Page['discount'] = lazy(() => import('./components/Sales/DiscountSetup/ViewDiscount'));
Page['discountForm'] = lazy(() => import('./components/Sales/DiscountSetup/FormDiscount'));

Page['exchangerate'] = lazy(() => import('./components/Sales/ExchangeRateSetup/ViewExchangeRate'));
Page['exchangerateForm'] = lazy(() => import('./components/Sales/ExchangeRateSetup/FormExchangeRate'));

Page['hotkey'] = lazy(() => import('./components/Sales/HotkeySetup/ViewHotkey'));
Page['hotkeyForm'] = lazy(() => import('./components/Sales/HotkeySetup/FormHotkey'));

Page['paymentmode'] = lazy(() => import('./components/Sales/PaymentModeSetup/ViewPaymentMode'));
Page['paymentmodeForm'] = lazy(() => import('./components/Sales/PaymentModeSetup/FormPaymentMode'));

Page['onlinesalesorder'] = lazy(() => import('./components/Sales/OnlineSalesOrder/ViewOnlineSalesOrder'));
Page['onlinesalesorderForm'] = lazy(() => import('./components/Sales/OnlineSalesOrder/FormOnlineSalesOrder'));

Page['onlinesaleschannel'] = lazy(() => import('./components/Sales/OnlineSalesChannel/ViewOnlineChannel'));
Page['onlinesaleschannelForm'] = lazy(() => import('./components/Sales/OnlineSalesChannel/FormOnlineSalesChannel'));

Page['surcharge'] = lazy(() => import('./components/Sales/SurchargeSetup/ViewSurcharge'));
Page['surchargeForm'] = lazy(() => import('./components/Sales/SurchargeSetup/FormSurcharge'));

Page['inventorylocation'] = lazy(() => import('./components/MasterData/InventoryLocationSetup/ViewInventoryLocation'));
Page['inventorylocationForm'] = lazy(() => import('./components/MasterData/InventoryLocationSetup/FormInventoryLocation'));

Page['inventorylocationgroup'] = lazy(() => import('./components/MasterData/InventoryLocationGroupSetup/ViewInventoryLocationGroup'));
Page['inventorylocationgroupForm'] = lazy(() => import('./components/MasterData/InventoryLocationGroupSetup/FormInventoryLocationGroup'));

Page['outlet'] = lazy(() => import('./components/MasterData/OutletSetup/ViewOutlet'));
Page['outletForm'] = lazy(() => import('./components/MasterData/OutletSetup/FormOutlet'));

Page['outletgroup'] = lazy(() => import('./components/MasterData/OutletGroupSetup/ViewOutletGroup'));
Page['outletgroupForm'] = lazy(() => import('./components/MasterData/OutletGroupSetup/FormOutletGroup'));

Page['pointofsale'] = lazy(() => import('./components/MasterData/PointofSaleSetup/ViewPointofSale'));
Page['pointofsaleForm'] = lazy(() => import('./components/MasterData/PointofSaleSetup/FormPointofSale'));

Page['posorderintegration'] = lazy(() => import('./components/MasterData/POSOrderIntegration/ViewPOSOrderIntegration'));
Page['posorderintegrationForm'] = lazy(() => import('./components/MasterData/POSOrderIntegration/FormPOSOrderIntegration'));

Page['membership'] = lazy(() => import('./components/Membership/MembershipSetup/ViewMembership'));
Page['membershipForm'] = lazy(() => import('./components/Membership/MembershipSetup/FormMembership'));

Page['membershipgroup'] = lazy(() => import('./components/Membership/MembershipGroupSetup/ViewMembershipGroup'));
Page['membershipgroupForm'] = lazy(() => import('./components/Membership/MembershipGroupSetup/FormMembershipGroup'));

Page['membershipbenefit'] = lazy(() => import('./components/Membership/MembershipBenefitSetup/ViewMembershipBenefit'));
Page['membershipbenefitForm'] = lazy(() => import('./components/Membership/MembershipBenefitSetup/FormMembershipBenefit'));

Page['referral'] = lazy(() => import('./components/Membership/ReferralSetup/ViewReferralSetup'));
Page['referralForm'] = lazy(() => import('./components/Membership/ReferralSetup/FormReferalSetup'));

Page['membershipvoucher'] = lazy(() => import('./components/Membership/VoucherSetup/ViewVoucherSetup'));
Page['membershipvoucherForm'] = lazy(() => import('./components/Membership/VoucherSetup/FormVoucherSetup'));

Page['storevaluecard'] = lazy(() => import('./components/Membership/StoreValueCard/ViewStoreValueCard'));
Page['storevaluecardForm'] = lazy(() => import('./components/Membership/StoreValueCard/FormStoreValueCard'));

Page['privilege'] = lazy(() => import('./components/User/PrivilegesSetup/ViewPrivileges'));
Page['privilegeForm'] = lazy(() => import('./components/User/PrivilegesSetup/FormPrivileges'));

Page['role'] = lazy(() => import('./components/User/RoleSetup/ViewRole'));
Page['roleForm'] = lazy(() => import('./components/User/RoleSetup/FormRole'));

Page['roleprivilege'] = lazy(() => import('./components/User/RolePrivilegesSetup/ViewRolePrivileges'));

Page['user'] = lazy(() => import('./components/User/UserSetup/ViewUser'));
Page['userForm'] = lazy(() => import('./components/User/UserSetup/FormUser'));

Page['supplier'] = lazy(() => import('./components/MasterData/SupplierSetup/ViewSupplier'));
Page['supplierForm'] = lazy(() => import('./components/MasterData/SupplierSetup/FormSupplier'));

Page['webhook'] = lazy(() => import('./components/Setting/WebhookSetup/ViewWebhook'));
Page['webhookForm'] = lazy(() => import('./components/Setting/WebhookSetup/FormWebhook'));

Page['guestbook'] = lazy(() => import('./components/Setting/GuestBookSetup/ViewGuestBook'));
Page['guestbookForm'] = lazy(() => import('./components/Setting/GuestBookSetup/FormGuestBook'));

Page['paymentmethodref'] = lazy(() => import('./components/MasterData/PaymentMethodRef/ViewPaymentMethodRef'));
Page['paymentmethodrefForm'] = lazy(() => import('./components/MasterData/PaymentMethodRef/FormPaymentMethodRef'));

Page['listvalue'] = lazy(() => import('./components/Setting/ListValue/ViewListValue'));
Page['listvalueForm'] = lazy(() => import('./components/Setting/ListValue/FormListValue'));

Page['customfield'] = lazy(() => import('./components/Setting/CustomField/ViewCustomField'));
Page['customfieldForm'] = lazy(() => import('./components/Setting/CustomField/FormCustomField'));

Page['appcommand'] = lazy(() => import('./components/Setting/AppCommand/ViewAppCommand'));
Page['appcommandForm'] = lazy(() => import('./components/Setting/AppCommand/FormAppCommand'));

Page['voucher'] = lazy(() => import('./components/Setting/VouchersSetup/ViewVouchers'));
Page['voucherForm'] = lazy(() => import('./components/Setting/VouchersSetup/FormVouchers'));

Page['stockoutreason'] = lazy(() => import('./components/Setting/StockOutSetup/ViewStockOut'));
Page['stockoutreasonForm'] = lazy(() => import('./components/Setting/StockOutSetup/FormStockOut'));

Page['feature'] = lazy(() => import('./components/Setting/FeatureSetup/ViewFeature'));

Page['installer'] = lazy(() => import('./components/Setting/Installer/ViewInstaller'));

Page['company'] = lazy(() => import('./components/Setting/CompanySetup/ViewCompany'));

Page['terminalstatus'] = lazy(() => import('./components/MasterData/TerminalStatus/ViewTerminalStatus'));

Page['productimporter'] = lazy(() => import('./components/DataImporter/ProductImporterSetup/ViewProductImporter'));

Page['recipeimporter'] = lazy(() => import('./components/DataImporter/RecipeImporterSetup/ViewRecipeImporter'));

Page['supplierproductimporter'] = lazy(() => import('./components/DataImporter/SupplierImporterSetup/ViewSupplierImporter'));

Page['membershipimporter'] = lazy(() => import('./components/DataImporter/MembershipImporterSetup/ViewMembershipImporter'));

Page['campaign'] = lazy(() => import('./components/Membership/CampaignSetup/ViewCampaignSetup'));
Page['campaignForm'] = lazy(() => import('./components/Membership/CampaignSetup/FormCampaignSetup'));

Page['promotionimporter'] = lazy(() => import('./components/DataImporter/PromotionImporterSetup/ViewPromotionImporter'));

Page['alternatebarcodeimporter'] = lazy(() => import('./components/DataImporter/AlternateBarcodeSetup/ViewAlternateBarcodeImporter'));

Page['outletitembalanceimporter'] = lazy(() => import('./components/DataImporter/OutletItemBalanceSetup/ViewOutletItemBalanceImporter'));

Page['simulatesales'] = lazy(() => import('./components/Sales/SimulateSales/SimulateSales'));

Page['commission'] = lazy(() => import('./components/Commission/CommissionSetup/ViewCommission'));
Page['commissionForm'] = lazy(() => import('./components/Commission/CommissionSetup/FormCommission'));

Page['virtualstock'] = lazy(() => import('./components/Product/OutletVirtualStockBalanceSetup/ViewOutletVirtualStockBalance'));
Page['gstsetup'] = lazy(() => import('./components/Setting/GSTSetup/ViewGSTSetup'));
Page['gstsetupForm'] = lazy(() => import('./components/Setting/GSTSetup/FormGSTSetup'));
Page['listvaluecategory'] = lazy(() => import('./components/MasterData/ListValueCategory/ViewListValueCategory'));

Page['termandcondition'] = lazy(() => import('./components/MasterData/SiteInfo'));
Page['privacypolicy'] = lazy(() => import('./components/MasterData/SiteInfo'));

Page['faq'] = lazy(() => import('./components/MasterData/FAQ/ViewFAQ'));
Page['faqForm'] = lazy(() => import('./components/MasterData/FAQ/FormFAQ'));

Page['dataexporter'] = lazy(() => import('./components/DataExporter/ViewDataExporter'));
Page['lowqtyimporter'] = lazy(() => import('./components/DataImporter/LowQtyImporter/ViewLowQtyImporter'));
Page['orderingsetup'] = lazy(() => import('./components/QROrdering/OrderingSetup'));
Page['orderingsetupForm'] = lazy(() => import('./components/QROrdering/OrderingSetup/FormOrderingSetup'));
Page['layoutsetup'] = lazy(() => import('./components/QROrdering/LayoutSetup'));
Page['paymentgateway'] = lazy(() => import('./components/QROrdering/PaymentGateway'));
Page['paymentgatewayForm'] = lazy(() => import('./components/QROrdering/PaymentGateway/FormPaymentGateway'));
Page['posterminalsettings'] = lazy(() => import('./components/Setting/PosTerminalSetting'));

Page['printdeliveryorder'] = lazy(() => import('./components/DeliveryOrder/PrintDeliveryOrder/ViewPrintDeliveryOrder'));
Page['printdeliveryorderForm'] = lazy(() => import('./components/DeliveryOrder/PrintDeliveryOrder/FormDeliveryOrder'));

Page['lockeduser'] = lazy(() => import('./components/User/LockedUser/ViewLockedUser'));
Page['imageproductimporter'] = lazy(() => import('./components/DataImporter/ImageProductImporter/ViewImageProductImporter'));
Page['membershipintegrationsettings'] = lazy(() => import('./components/Membership/MembershipIntegrationSettings'));

Page['newpromotion'] = lazy(() => import('./components/Promotion/NewPromotion/ViewPromotion'));  
Page['newpromotionForm'] = lazy(() => import('./components/Promotion/NewPromotion/FormNewPromotion'));

Page['bannerdisplay'] = lazy(() => import('./components/Setting/BannerDisplay/ViewBannerDisplay'));
Page['bannerdisplayForm'] = lazy(() => import('./components/Setting/BannerDisplay/FormBannerDisplay'));

Page['broadcast'] = lazy(() => import('./components/Setting/Broadcast/ViewBroadcast'));
Page['broadcastForm'] = lazy(() => import('./components/Setting/Broadcast/FormBroadcast'));

Page['autodrive'] = lazy(() => import('./components/Setting/AutoDrive/ViewAutoDrive'));
Page['autodriveForm'] = lazy(() => import('./components/Setting/AutoDrive/FormAutoDrive'));

Page['onlinemenusetup'] = lazy(() => import('./components/OnlineMenuSetup/ViewOnlineMenuSetup'));
Page['onlinemenusetupForm'] = lazy(() => import('./components/OnlineMenuSetup/FormOnlineMenuSetup'));

Page['futureproductprice'] = lazy(() => import('./components/DataImporter/FutureProductPrice/ViewFutureProductPrice'));

Page['outletpricing'] = lazy(() => import('./components/OutletPricing/ViewOutletPricing'));

Page['barcodeprinting'] = lazy(() => import('./components/Product/BarcodePrinting'));

// Page['menubuilder'] = lazy(() => import('./components/MenuManagement/MenuBuilder'));
Page['menubuilder'] = lazy(() => import('./components/MenuManagement/MenuBuilder/FormMenuBuilder'));
// Page['menubuilderForm'] = lazy(() => import('./components/MenuManagement/MenuBuilder/FormMenuBuilder'));

Page['timewindow'] = lazy(() => import('./components/MenuManagement/TimeWindow'));
Page['timewindowForm'] = lazy(() => import('./components/MenuManagement/TimeWindow/FormTimeWindow'));

Page['recipes'] = lazy(() => import('./components/RecipeInstruction/ViewRecipeInstruction'));
Page['recipesForm'] = lazy(() => import('./components/RecipeInstruction/FormRecipeInstruction'));

const Routes = ( { location }) => {
    const currentKey = location.pathname.split('/')[1] || '/';
    const timeout = { enter: 500, exit: 500 };

    const animationName = 'rag-fadeInLeft'

    const generateRouters = () => {
        const rawState = ls.get(STORAGE_KEY, { decrypt: true });

        if (rawState === null) return ;
        const state = JSON.parse(rawState);

        let menuList = state.menu.listMenu;

        let el = []

        if(!menuList) return;

        for(const menu of menuList){
            if(!menu.submenu) continue;
            for(const submenu of menu.submenu){
                let cleanPath = submenu.path.substring(1);
                let path = submenu.path

                if(path.includes('listvalue') && !path.includes('listvaluecategory')) {
                    path = '/listvalue';
                    cleanPath = 'listvalue'
                }

                try {
                    el.push(<Route exact path={path} component={waitFor(Page[cleanPath])}/>)
                    el.push(<Route exact path={`${path}/edit/:id`} component={waitFor(Page[cleanPath+'Form'])}/>)
                    el.push(<Route exact path={`${path}/add`} component={waitFor(Page[cleanPath+'Form'])}/>)
                } catch (error) {
                    // console.log(path, cleanPath)
                }
            }
        }

        return el;
    }

    if(listofPages.indexOf(location.pathname) > -1) {
        return (
            // Page Layout component wrapper
            <BasePage>
                <Suspense fallback={<PageLoader/>}>
                    <Switch location={location}>
                        <Route exact path={`/login`} component={waitFor(Page['Login'])}/>
                        <Route exact path={`/resetpassword`} component={waitFor(Page['ResetPassword'])}/>
                        <Route exact path={`/unauthorized`} component={waitFor(Page['UnAuthorized'])} />
                        <Route exact path={`/lock`} component={waitFor(Page['Lock'])}/>
                        <Route exact path={`/loginsuccess`} component={waitFor(Page['Authorized'])}/>
                        <Route exact path={`/logout`} component={waitFor(Page['logout'])}/>
                        
                    </Switch>
                </Suspense>
            </BasePage>
        )
    }
    else {
        return (
            // Layout component wrapper
            <Base>
              <TransitionGroup>
                <CSSTransition key={currentKey} timeout={timeout} classNames={animationName} exit={false}>
                    <div>
                        <Suspense fallback={<PageLoader/>}>
                            <Switch location={location}>
                                <Route exact path={`/`} component={waitFor(Page['Home'])}/>
                                <Route exact path={`/profil`} component={waitFor(Page['Profil'])}/>
                                <Route exact path={`/home`} component={waitFor(Page['Home'])}/>
                                <Route exact path={`/noaccess`} component={waitFor(Page['NoAccess'])}/>
                                <Route exact path={`/logout`} component={waitFor(Page['logout'])}/>
                                {generateRouters()}
                                {Object.keys(store.getState().user.userInfo).length<1?
                                    <Redirect to={`/login`}/>:
                                    <Redirect to={`/noaccess`}/>}
                                    
                            </Switch>
                        </Suspense>
                    </div>
                </CSSTransition>
              </TransitionGroup>
            </Base>
        )
    }
}

Routes.propTypes = {
    location: PropTypes.object.isRequired
}

export default withRouter(Routes);